import { FormGroup as ReactStrapFormGroup } from "reactstrap"
import { FormGroupProps } from "reactstrap/types/lib/FormGroup"

export function FormGroup(props: FormGroupProps) {
  return (
    <ReactStrapFormGroup data-form-field {...props} />
  )
}
